import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

import { FCWithChildren } from 'common/types';

const Root = styled.div`
  display: grid;
  height: 100vh;
  grid-template-columns: 0.6fr minmax(0, 1fr);
  grid-template-rows: 66px 1fr;
  grid-template-areas:
    'top-bar top-bar'
    'form preview';
`;

const Form = styled.div`
  grid-area: form;
  overflow-y: auto;
  padding-bottom: ${({ theme }) => theme.spacings.abs64}px;
`;

const Preview: FCWithChildren = (props) => {
  return (
    <Box
      backgroundColor="grey.200"
      gridArea="preview"
      overflowY="auto"
      padding="space-24"
      {...props}
    />
  );
};

const TopBar = styled.div`
  grid-area: top-bar;
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.grey(2)};
`;

/**
 * Layout for invoice/quote creation form
 */
const FormPageLayout = {
  Form,
  Preview,
  Root,
  TopBar,
};

export default FormPageLayout;
